// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-3acmr","checkbox_checked":"checkbox_checked-29Rvq","label":"label-2cDIr"};